<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group
          @reset="$gjReset"
          @query="$gjNoticeQuery"
      >
        <gj-country-server-select
            v-model="filter.countryMarketValue"
        >
        </gj-country-server-select>
        <gj-search-input
            v-model="filter.ruleName"
            placeholder="全部规则"
            width="150px"
        >
        </gj-search-input>
        <gj-select
            v-model="filter.result"
            :options="option.sendRecordResult"
            placeholder="全部结果"
        >
        </gj-select>
        <gj-select-input
            :options="[
              {id: 'orderId', text: '订单编号'},
              {id: 'asin', text: 'ASIN'},
              {id: 'msku', text: 'MSKU'},
          ]"
            :value="filter.keyword"
        >
        </gj-select-input>
        <gj-select-date-picker
            type="daterange"
            v-model="filter.date"
            :options="[
              {id: 'requestDate', text: '请求时间'},
              {id: 'purchaseDate', text: '订购时间'},
              {id: 'shippingDate', text: '发货时间'},
          ]"
        ></gj-select-date-picker>

        <template #right>
          <view-setting
                  :ref="REF_VIEW_SETTING"
                  save-mode="remote"
                  :use-default="true"
                  :module-name="moduleName"
                  :config="model"
                  :fn-generate-params="generateViewParams"
                  @view-change="handleChangeView"
                  @view-complete="handCompleteView"
          >
          </view-setting>
          <gj-tool-group help></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table
          :columns="columns"
          adaptParent
          :data="data"
          :loading="loading"
          :pagination="pagination"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
      >
        <template v-slot:orderId="{ row }">
          <template v-if="$permission('requestRule:viewOrder')">
            <gj-button type="text" @click="orderDetailModal(row)">{{row.orderId}}</gj-button>
            <span v-copy="row.orderId"
              class="copy-icon gj-cell-display-switch">
              <gj-icon class="el-icon-copy-document"></gj-icon>
            </span>
          </template>
          <template v-else>
            {{row.orderId}}
          </template>
        </template>
        <template v-slot:productName="{ row }">
          <template v-for="(item, index) in row.items">
            <div :key="item.id" :class="[(index + 1) !== row.items.lenght ? 'order-item-mg8' : '']">
              <gj-tooltip :content="item.title">
                {{item.productName}}
              </gj-tooltip>
              <el-row>
                <el-col :span="10">
                  <el-row>
                    <el-col :span="20">
                      {{item.asin}}
                    </el-col>
                    <el-col :span="4">
                      <span v-copy="item.asin"
                            class="copy-icon gj-cell-display-switch">
                        <gj-icon class="el-icon-copy-document"></gj-icon>
                      </span>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="14">
                  <el-row>
                    <el-col :span="21">
                      <gj-tooltip :content="item.msku">
                        {{item.msku || '-'}}
                      </gj-tooltip>
                    </el-col>
                    <el-col :span="3">
                      <span v-copy="item.msku"
                            class="copy-icon gj-cell-display-switch">
                        <gj-icon class="el-icon-copy-document"></gj-icon>
                      </span>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </template>
        </template>
        <template v-slot:resultDesc="{ row }">
          <gj-tooltip :text-line="2" :content="row.resultDesc">
            {{row.resultDesc  | defaultShow}}
          </gj-tooltip>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {subDays} from 'date-fns'
  import SaleOrderDetail from "../../sale/saleOrder/modal/sale-order-detail";
  import {queryMixin} from "../../../../minxins";
  import {sendRecordResult} from "../../../../utils/options";
  import {convertToDate, generateViewParams} from "../../../../utils/date.util";
  import {getSendRecord, getSendRuleDetail} from "../../../../api/crm";
  import {mapGetters} from "vuex";
  import viewConfig from './viewConfig'

  export default {
    name: "send-record",
    mixins: [queryMixin],
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    data() {
      return {
        data: [],
        columns: [
          {id: 'marketId', header: '店铺/国家', field: 'option:marketId', minWidth: '85px', default: true, options: () => this.marketOption},
          {id: 'orderId', header: '订单编号', field: 'slot:orderId', minWidth: '130px', default: true},
          {id: 'productName', header: 'ASIN', field: 'asin', minWidth: '100px', default: true},
          {id: 'ruleName', header: '规则名称', field: 'ruleName', minWidth: '110px', default: true},
          {id: 'purchaseDate', header: '订购时间', field: 'purchaseDate', minWidth: '130px', default: true, sortable: true},
          {id: 'deliveryDate', header: '发货时间', field: 'deliveryDate', minWidth: '130px', default: true, sortable: true},
          {id: 'expectedDeliveryTime', header: '预计送达时间', field: 'expectedDeliveryTime', minWidth: '130px', default: true, sortable: true},
          {
            id: 'result',
            header: '请求结果',
            field: 'option:result',
            width: '180px',
            default: true,
            options: sendRecordResult
          },
          {id: 'resultDesc', header: '说明', field: 'slot:resultDesc', minWidth: '200px', default: true},
          {id: 'requestTime', header: '请求时间', field: 'requestTime', minWidth: '150px', default: true, sortable: true},
        ],
        filter: {
          ruleName: null,
          countryMarketValue: null,
          result: null,
          keyword: {
            key: 'orderId',
            value: null,
          },
          date: {
            key: 'requestDate',
            value: [subDays(new Date(), 4), new Date()]
          }
        },
        option: {
          sendRecordResult: sendRecordResult,
        },
        moduleName: 'SEND_RECORD',
        model: viewConfig
      }
    },
    methods: {
      generateViewParams,
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams (params) {
        const date = params.date ? params.date : { key: params.dateType, value: [params.startDateTime, params.endDateTime]}
        this.filter = Object.assign({}, this.filter, {
          ...params,
          date
        })
      },
      orderDetailModal(row) {
        this.$gjCreate(SaleOrderDetail)
      },
      $gjQuery() {
        this.loading = true;
        const params = {
          model: {
            ruleName: this.filter.ruleName,
            result: this.filter.result,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        params.model[this.filter.keyword.key] = this.filter.keyword.value;
        if (this.filter.countryMarketValue) {
          params.model.countryCodes = this.filter.countryMarketValue.countryIds;
          params.model.marketIds = this.filter.countryMarketValue.marketIds;
        }
        if (this.filter.date.value !== null) {
          if (this.filter.date.key === 'requestDate') {
            params.model['requestStartTime'] = convertToDate(this.filter.date.value[0]);
            params.model['requestEndTime'] = convertToDate(this.filter.date.value[1]);
          } else if (this.filter.date.key === 'purchaseDate') {
            params.model['purchaseStartDate'] = convertToDate(this.filter.date.value[0]);
            params.model['purchaseEndDate'] = convertToDate(this.filter.date.value[1]);
          } else {
            params.model['deliveryStartDate'] = convertToDate(this.filter.date.value[0]);
            params.model['deliveryEndDate'] = convertToDate(this.filter.date.value[1]);
          }
        }
        getSendRecord(params)
          .complete(() => this.loading = false)
          .then((result) => {
            this.data = result.records;
            this.pagination = this.getPagination(result);
          })
      },
      $gjQueryInitParams() {
        return {
          filter: {
            ruleName: null,
            countryMarketValue: null,
            result: null,
            keyword: {
              key: 'orderId',
              value: null,
            },
            date: {
              key: 'requestDate',
              value: [subDays(new Date(), 4), new Date()]
            }
          },
        }
      }

    }
  }
</script>

<style scoped lang="scss">
  .order-item-mg8 {
    margin-bottom: 8px;
  }
  /deep/ .send-record-rule-name {
    .el-button {
      white-space: inherit;
      width: 110px;
      text-align: left;
      padding-right: 5px;
      line-height: 1.2;
    }
  }
   
</style>
